import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class CookieService {

	get(name: string): string | null {
			const value = document.cookie.split('; ').find((row) => row.startsWith(`${name}=`));
			return value ? decodeURIComponent(value.split('=')[1]) : null;
	}

	set(
		name: string,
		value: string,
		options: {
			path?: string;
			expires?: number; // in days
			secure?: boolean;
			sameSite?: 'Lax' | 'Strict' | 'None';
		} = {}
	): void {
			const {
				path = '/',
				expires = 7,
				secure = false, // ✅ default to false for dev
				sameSite = 'Lax',
			} = options;

			let cookieString = `${name}=${encodeURIComponent(value)}`;
			cookieString += `; Path=${path}`;
			cookieString += `; Max-Age=${expires * 24 * 60 * 60}`;

			// ✅ Proper casing
			if (secure && location.protocol === 'https:') {
				cookieString += '; Secure';
			}

			cookieString += `; SameSite=${sameSite}`;

			document.cookie = cookieString;
		
	}

	/**
	 * Deletes a cookie by name (browser only).
	 */
	clear(name: string, path = '/'): void {
			document.cookie = `${name}=; path=${path}; max-age=0`;
		
	}
}
